import { render, staticRenderFns } from "./industryList.vue?vue&type=template&id=fafaa4a6&scoped=true"
import script from "./industryList.vue?vue&type=script&lang=js"
export * from "./industryList.vue?vue&type=script&lang=js"
import style0 from "./industryList.vue?vue&type=style&index=0&id=fafaa4a6&prod&lang=scss"
import style1 from "./industryList.vue?vue&type=style&index=1&id=fafaa4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafaa4a6",
  null
  
)

export default component.exports